import { AddFundsButton } from '../Buttons/AddFunds/AddFundsButton';

import './styles/addFundsWrapperStyle.scss';
import { useShallow } from 'zustand/react/shallow';
import { useStore } from '@/store/useStore';
import { formatWalletBalance } from '@/utilities/helpers/formatWalletBalance';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { BRANDS } from '@/utilities/constants/game';

export const AddFundsWrapper = ({
  showBalance,
  size,
  label = 'ADD FUNDS',
}: AddFundsProps) => {
  const orientation = useAppOrientation();
  const isMohegansun = useStore((s) => s.runtime.brand) === BRANDS.MOHEGANSUN;
  const { showDepositButton, showGameWindow, depositLink } = useStore(
    useShallow((s) => s.commonUIContext),
  );
  const { balance, loadingGetBalance } = useStore(
    useShallow((s) => ({
      balance: s.gameWindowContext.balance,
      loadingGetBalance: s.gameWindowContext.loadingGetBalance,
    })),
  );
  const wrapperType = useStore((s) => s.runtime.wrapperType);
  const showLoadingPlaceholder = loadingGetBalance && balance === null;

  return showDepositButton && showGameWindow && orientation ? (
    <div className={`add-funds-wrapper ${orientation}`}>
      <div className="label-balance-container">
        {showBalance && (
          <div className={`balance-display`} data-testid="balance-display">
            {showLoadingPlaceholder
              ? 'Loading...'
              : formatWalletBalance(balance ?? undefined)}
          </div>
        )}
        {!isMohegansun && (
          <div className={`add-funds-label ${orientation}`}>{label}</div>
        )}
      </div>

      <AddFundsButton
        size={size}
        isMobile={wrapperType.isAndroid}
        depositLink={depositLink ?? ''}
      />
    </div>
  ) : null;
};

interface AddFundsProps {
  showBalance?: boolean;
  size?: number;
  label?: string;
}
